export const cashBoxDefinedBasicSocketKeys = [
    "ack_received",
] as const;

export const cashBoxDefinedSocketKeys = [
    "success_viva_wallet_transaction",
    "create_receipt",
    "update_receipt",
    "delete_order",
] as const;
